import {
  roundDetailsFailureAction,
  roundDetailsRequestAction,
  roundDetailsSuccessAction,
  playerHistoryActions as playerHistoryActionsFromSlice,
} from '../reducers/playerHistory';

export const playerHistoryActions = {
  playerHistory: playerHistoryActionsFromSlice,
  roundDetails: {
    request: roundDetailsRequestAction,
    success: roundDetailsSuccessAction,
    failure: roundDetailsFailureAction,
  },
};
